<template>
  <div class="year-frame-export-container">
    <el-button icon="el-icon-download" type="primary" @click="handelClick">导出</el-button>
    <div v-if="loading" class="mask">
      <div style="text-align: center;">
        <el-progress type="circle" :percentage="percentage" text-color="white"/>
        <h2 style="color: #FFFFFF;text-align: center;">下载中...</h2>
        <h3 style="color: #FFFFFF;text-align: center;">
          下载数 {{ total }} 条，已用时 {{ (interval_ms / 1000)|numberFormat(2) }} s</h3>
      </div>
    </div>
  </div>
</template>
<script>
import {export_json_to_excel} from '@/utils/export/excel'
import {yearFrameList} from "@/api/customerYearFrame";

const MapStatus = {
  WAIT: 0,
  PASS: 1,
  REJECT: 2,
  CANCEL: 3,
}
const statusMap = {
  [MapStatus.WAIT]: '待审核',
  [MapStatus.PASS]: '通过',
  [MapStatus.REJECT]: '拒绝',
  [MapStatus.CANCEL]: '撤回',
};

/**
 * 导出头部
 */
const fieldMap = {
  '序号': 'index',
  '客户名称': '_customer_name', // 处理
  '集团': '_combine_name', // 处理
  '申请类型': '_type',// 处理
  '状态': '_status',// 处理
  '开拓者': '_pioneer_name',// 处理
  '销售': '_sales',// 处理
  '申请人': 'creator',
  '签约开始': 'sign_begin',
  '签约截至': 'sign_end',
  '年框政策': 'policy_alias',
  '付款方式': '_pay_method',
  '最高级别负责人': 'charge_person',
  '职位': 'post',
  '申请时间': 'created_at',
  '说明': '_remark',// 处理
}
export default {
  name: 'YearFrameExport',
  props: {
    search: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      interval: null,
      interval_ms: 0,
      total: 0,
      percentage: 0
    }
  },
  methods: {
    handelClick() {
      this.$emit('start')
    },
    handelStart: async function (params) {
      const _this = this
      _this.interval_ms = 0
      _this.interval_ms && clearInterval(_this.interval_ms)
      const callback = () => {
        _this.$message.success('导出成功')
        _this.interval_ms && clearInterval(_this.interval_ms)
      }
      _this.interval = setInterval(function () {
        _this.interval_ms += 10
      }, 10)

      _this.percentage = 0
      this.loading = true
      const json = await this.getData(params)
      this.loading = false
      const {array: tableData, merges} = this.filterJson(json)

      export_json_to_excel(
        {
          fieldMap,
          sourceData: tableData,
          filename: '导出数据',
          mergeColumns: merges
        }, callback
      )
    },
    getData: async function (search) {
      const _this = this
      let array = []
      const params = {...{}, ...search}
      params.page = 1
      params.page_size = 50
      const {model: {total}} = await yearFrameList(params)
      this.total = total
      for (let i = 0; i < total; i += params.page_size) {
        const {model: {data}} = await yearFrameList(params)
        array = [...array, ...data]
        params.page++
        _this.percentage = parseInt((i / total * 100) + '')
      }
      return array
    },
    filterJson(json) {

      const array = []
      const merges = []
      json.forEach((row, index) => {
        const obj = {...{}, ...row}
        obj.index = index + 1
        obj._customer_name = row.customer && row.customer.name ? row.customer.name : ''
        obj._combine_name = row.combine && row.combine.name ? row.combine.name : ''
        obj._type = row.type === 'TO_N' ? '取消年框' : '申请年框'
        obj._status = statusMap[row.status] || ''
        obj._pioneer_name = row.customer && row.customer.pioneer_name ? row.customer.pioneer_name : ''
        obj._sales = Array.isArray(row.then_sales) ? row.then_sales.join('、') : '-'
        obj._pay_method = row.pay_method && row.pay_method_sub ? row.pay_method + '-' + row.pay_method_sub : row.pay_method
        obj._remark = `${row.creator_remark ? `申请人：${row.creator_remark}；` : ''}${row.audit_remark ? `审核人：${row.audit_remark}；` : ''}`
        array.push(obj)
      })
      return {array, merges}
    }
  }
}

</script>
<style lang="scss">
.year-frame-export-container {
  .el-button [class*=el-icon-] + span {
    margin-left: 0;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .8); /*一般遮罩随便设置一个颜色*/
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
